import { Exhibits } from "./exhibits";
import { Game } from "./game";
import { my360meshall } from "./360crnew";
import { texture360 } from "./360newtry";
import { GlobalControl } from "./globalControl";
import { VeryNettyPara } from "./veryNetty/VeryNettyPara";

export class tex_create {

	public position: BABYLON.Vector3 = new BABYLON.Vector3(0, 0, 0);//摄像机位置
	public my_w: number = 4096;//图片宽度
	public my_h: number = 4096;//图片长度
	public camera: BABYLON.FreeCamera;//截图所用摄像机
	test_tex_array: Array<BABYLON.Texture> = new Array();//存6张图片的数组
	public photoName: string = "c_1";//生成照片的名称

	//6张图片的二进制数组
	l1: BABYLON.Nullable<ArrayBufferView> = null;
	l2: BABYLON.Nullable<ArrayBufferView> = null;
	l3: BABYLON.Nullable<ArrayBufferView> = null;
	l4: BABYLON.Nullable<ArrayBufferView> = null;
	l5: BABYLON.Nullable<ArrayBufferView> = null;
	l6: BABYLON.Nullable<ArrayBufferView> = null;

	//触发判读
	private _observer: Nullable<BABYLON.Observer<BABYLON.Scene>> = null;
	//第一次触发判断
	FIRST_IN = false;
	//计数器
	count = 0;
	//方盒 用全景图作为材质 方便截图
	box: BABYLON.Mesh | null = null;

	//构造函数 初始化
	public constructor(engine: BABYLON.Engine, scene: BABYLON.Scene, name: string) {
		//初始化默认相机
		this.camera = new BABYLON.FreeCamera("camera"+name, new BABYLON.Vector3(0, 170, 0), scene);
		//初始化默认box
		this.box = BABYLON.Mesh.CreateBox("box"+name, 170, scene);
		this.box.rotation.y += Math.PI / 2;
		//设置box不可见
		this.box.setEnabled(false);
		let tt = new my360meshall();
		let Mat = new BABYLON.StandardMaterial("mat", scene);
		tt.my_create(scene, Mat, name);
		let obj = scene.getMeshByName(name);
		if (obj != null)
			obj.setEnabled(false);
	}

	//传入想要的摄像机位置 创建6张图片
	public set_position(p: BABYLON.Vector3, name: string, engine: BABYLON.Engine, scene: BABYLON.Scene) {
		console.log("循环次数")
		//调整摄像机位置
		this.camera.position = p;
		//调整角度
		this.camera.fov = (Math.PI / 4) * 2.0;
		//调整摄像机模式
		this.camera.fovMode = BABYLON.Camera.FOVMODE_HORIZONTAL_FIXED;
		//调整摄像机机朝向
		this.camera.rotation.y = 0;
		let that = this;
		this.test_tex_array.length = 0;

		let w = 2048;
		let h = 2048;
		//调整摄像机 截取6张图片
		//TO DO:需要异步
		BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, this.camera, { width: w, height: h }, function (data) {
			let tex_new1 = new BABYLON.Texture(data, scene);
			that.test_tex_array.push(tex_new1);

		})
		this.camera.rotation.y += Math.PI / 2;

		BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, this.camera, { width: w, height: h }, function (data) {
			let tex_new1 = new BABYLON.Texture(data, scene);
			that.test_tex_array.push(tex_new1);
		})
		this.camera.rotation.y += Math.PI / 2;

		BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, this.camera, { width: w, height: h }, function (data) {
			let tex_new1 = new BABYLON.Texture(data, scene);
			that.test_tex_array.push(tex_new1);//   

		})
		this.camera.rotation.y += Math.PI / 2;
		// console.log(this.camera.rotation.y);
		BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, this.camera, { width: w, height: h }, function (data) {
			let tex_new1 = new BABYLON.Texture(data, scene);
			that.test_tex_array.push(tex_new1);
		})

		this.camera.rotation.y += Math.PI / 2;
		this.camera.rotation.x += Math.PI / 2;
		BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, this.camera, { width: w, height: h }, function (data) {
			let tex_new1 = new BABYLON.Texture(data, scene);
			that.test_tex_array.push(tex_new1);
		})
		this.camera.rotation.x -= Math.PI;
		BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, this.camera, { width: w, height: h }, function (data) {
			let tex_new1 = new BABYLON.Texture(data, scene);
			that.test_tex_array.push(tex_new1);

			that.FIRST_IN = true;
			that.photoName = name;
			console.log(that.test_tex_array)
			that.test_tex_array[5].onLoadObservable.addOnce(() => {
				console.log("finally ready!");
				that.convertToOneEquirectangular(engine, scene, name)
			})
		})
	}


	public async convertToOneEquirectangular(engine: BABYLON.Engine, scene: BABYLON.Scene, name: string) {
		let that = this;
		//读取图片信息
		let back1 = await that.test_tex_array[2].readPixels();
		let right1 = await that.test_tex_array[1].readPixels();
		let front1 = await that.test_tex_array[0].readPixels();
		let left1 = await that.test_tex_array[3].readPixels();
		let top1 = await that.test_tex_array[5].readPixels();
		let bot1 = await that.test_tex_array[4].readPixels();

		if (left1 != null && right1 != null && top1 != null && bot1 != null && front1 != null && back1 != null && this.FIRST_IN)
		{
			that.FIRST_IN = false;
			that.position = that.camera.position;
			if (left1 != null && right1 != null && top1 != null && bot1 != null && front1 != null && back1 != null) {
				//二进制化
				let back = new Uint8ClampedArray(back1.buffer);
				let front = new Uint8ClampedArray(front1.buffer);
				let top = new Uint8ClampedArray(top1.buffer);
				let bot = new Uint8ClampedArray(bot1.buffer);
				let left = new Uint8ClampedArray(left1.buffer);
				let right = new Uint8ClampedArray(right1.buffer);

				let tex = texture360.gentexture(scene, left, right, top, bot, front, back,2048*8,2048,0);
				let obj = scene.getMeshByName("new" + name);//custom5
				let mat = new BABYLON.StandardMaterial(name + "mat", scene);

				tex.then((data) => {
					mat.diffuseTexture = data;
					mat.emissiveColor = BABYLON.Color3.White();
					mat.ambientColor = BABYLON.Color3.White();
				})
					.then(() => {
						if (obj != null) {
							obj.material = mat;
							obj.position.x = that.camera.position.x;
							obj.position.y = that.camera.position.y;
							obj.position.z = that.camera.position.z;
							obj.position.z += 40;
							obj.setEnabled(true);
							that.camera.rotation.x += Math.PI / 2;
						}
					})
					.then(() => {
						//根据6张图片创建全景图
						//截图并下载
						setTimeout(() => {
							BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, that.camera, { width: 4096, height: 4096 }, function (data) {
								GlobalControl.exhibits.uploadBase64Img(data, VeryNettyPara.ProjectID + "/360/" + that.photoName + ".png", GlobalControl.exhibits.applyTokenDo())
							})
							that.FIRST_IN = false;
							that.test_tex_array.length = 0;
							if (obj != null) {
								obj.setEnabled(false);
							}
						}, 1000)
					})
			}
		}
	}

	//根据6张图片创建全景图
	public async ConvertToEquirectangular(scene: BABYLON.Scene, left: Uint8ClampedArray, right: Uint8ClampedArray, top: Uint8ClampedArray, bot: Uint8ClampedArray, front: Uint8ClampedArray, back: Uint8ClampedArray, outputWidth: number, outputHeight: number) {
		//创建一张动态贴图并把它二进制化
		let texture = new BABYLON.DynamicTexture("dynamic texture", { width: this.my_w, height: this.my_h }, scene, true);
		let pixeldata = await texture.readPixels();
		if (pixeldata == null)
			return;
		let arr = new Uint8ClampedArray(pixeldata.buffer);


		//       Texture2D equiTexture = new Texture2D(outputWidth,outputHeight,TextureFormat.ARGB32,false); 
		//		//标准化纹理坐标,从0到1,从左下角开始
		let u: number = 0;
		let v: number = 0;
		//极坐标
		let phi: number = 0;
		let theta = 0;
		let cubeFaceWidth = 2048;// sourceTexture.width / 4; // 4个水平面
		let cubeFaceHeight = 2048;// sourceTexture.height / 3; // 3个垂直面
		let tempc = 0;
		let first = true;

		//遍历像素点 安经纬度对应获取对应的值
		for (let j = 0; j < this.my_h; j++) {
			//行从底部开始
			v = 1 - (j / this.my_h);
			theta = v * Math.PI;

			for (let i = 0; i < this.my_w; i++) {
				//列从左边开始
				u = (i / this.my_w);
				phi = u * 2 * Math.PI;

				//float x,y,z; //单位向量
				let x = Math.sin(phi) * Math.sin(theta) * -1;
				let y = Math.cos(theta);
				let z = Math.cos(phi) * Math.sin(theta) * -1;
				let a = 0; //{Math.abs(x),Math.abs(y),Math.abs(z)}

				if (Math.abs(x) >= Math.abs(y))
					a = Math.abs(x);
				else
					a = Math.abs(y);

				if (a < Math.abs(z))
					a = Math.abs(z);


				//向量平行于位于其中一个立方体面上的单位向量
				let xa = x / a;
				let ya = y / a;
				let za = z / a;

				let xOffset = 0;
				let yOffset = 0;
				let xPixel = 0;
				let yPixel = 0;

				if (xa == 1) {
					// Right 
					xPixel = ((((za + 1) / 2) - 1) * cubeFaceWidth);
					xPixel = Math.round(xPixel);
					xOffset = 2 * cubeFaceWidth; //偏移
					yPixel = ((((ya + 1) / 2)) * cubeFaceHeight);
					yPixel = Math.round(yPixel);


					yOffset = cubeFaceHeight; // Offset 
					xPixel = Math.abs(xPixel);
					yPixel = Math.abs(yPixel);

					xPixel += xOffset;
					yPixel += yOffset;

					xPixel -= 2 * cubeFaceWidth;
					yPixel -= cubeFaceHeight;


					if (first) {
						first = false;
					}
					if (xPixel >= 2048)
						xPixel = 2047;
					if (yPixel >= 2048)
						yPixel = 2047;

					arr[this.my_h * i * 4 + j * 4] = right[cubeFaceHeight * yPixel * 4 + xPixel * 4];//right
					arr[this.my_h * i * 4 + j * 4 + 1] = right[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 1];
					arr[this.my_h * i * 4 + j * 4 + 2] = right[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 2];
					arr[this.my_h * i * 4 + j * 4 + 3] = right[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 3];

				}
				else if (xa == -1) {
					//左
					xPixel = ((((za + 1) / 2)) * cubeFaceWidth);
					xPixel = Math.round(xPixel);
					xOffset = 0;
					yPixel = ((((ya + 1) / 2)) * cubeFaceHeight);
					yPixel = Math.round(yPixel);
					yOffset = cubeFaceHeight;
					xPixel = Math.abs(xPixel);
					yPixel = Math.abs(yPixel);

					xPixel += xOffset;
					yPixel += yOffset;
					if (xPixel == cubeFaceWidth)
						xPixel -= 1;

					//	xPixel-=2*cubeFaceWidth;
					yPixel -= cubeFaceHeight;
					if (xPixel >= 2048)
						xPixel = 2047;
					if (yPixel >= 2048)
						yPixel = 2047;
					arr[this.my_h * i * 4 + j * 4] = left[cubeFaceHeight * yPixel * 4 + xPixel * 4];
					arr[this.my_h * i * 4 + j * 4 + 1] = left[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 1];
					arr[this.my_h * i * 4 + j * 4 + 2] = left[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 2];
					arr[this.my_h * i * 4 + j * 4 + 3] = left[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 3];
				}
				else if (ya == 1) {
					// Up 
					xPixel = ((((xa + 1) / 2)) * cubeFaceWidth); xPixel = Math.round(xPixel);
					xOffset = cubeFaceWidth;
					yPixel = ((((za + 1) / 2) - 1) * cubeFaceHeight); yPixel = Math.round(yPixel);
					yOffset = 2 * cubeFaceHeight;
					xPixel = Math.abs(xPixel);
					yPixel = Math.abs(yPixel);

					xPixel += xOffset;
					yPixel += yOffset;

					xPixel -= cubeFaceWidth;
					yPixel -= 2 * cubeFaceHeight;
					if (xPixel >= 2048)
						xPixel = 2047; if (yPixel >= 2048)
						yPixel = 2047;
					arr[this.my_h * i * 4 + j * 4] = top[cubeFaceHeight * yPixel * 4 + xPixel * 4];
					arr[this.my_h * i * 4 + j * 4 + 1] = top[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 1];
					arr[this.my_h * i * 4 + j * 4 + 2] = top[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 2];
					arr[this.my_h * i * 4 + j * 4 + 3] = top[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 3];
				}
				else if (ya == -1) {
					// Down 
					xPixel = ((((xa + 1) / 2)) * cubeFaceWidth); xPixel = Math.round(xPixel);
					xOffset = cubeFaceWidth;
					yPixel = ((((za + 1) / 2)) * cubeFaceHeight); yPixel = Math.round(yPixel);
					yOffset = 0;
					xPixel = Math.abs(xPixel);
					yPixel = Math.abs(yPixel);

					xPixel += xOffset;
					yPixel += yOffset;

					xPixel -= cubeFaceWidth;
					//		yPixel-=2*cubeFaceHeight;
					if (xPixel >= 2048)
						xPixel = 2047; if (yPixel >= 2048)
						yPixel = 2047;
					arr[this.my_h * i * 4 + j * 4] = bot[cubeFaceHeight * yPixel * 4 + xPixel * 4];
					arr[this.my_h * i * 4 + j * 4 + 1] = bot[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 1];
					arr[this.my_h * i * 4 + j * 4 + 2] = bot[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 2];
					arr[this.my_h * i * 4 + j * 4 + 3] = bot[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 3];
				}
				else if (za == 1) {
					//前
					xPixel = ((((xa + 1) / 2)) * cubeFaceWidth); xPixel = Math.round(xPixel);
					xOffset = cubeFaceWidth;
					yPixel = ((((ya + 1) / 2)) * cubeFaceHeight); yPixel = Math.round(yPixel);
					yOffset = cubeFaceHeight;
					xPixel = Math.abs(xPixel);
					yPixel = Math.abs(yPixel);

					xPixel += xOffset;
					yPixel += yOffset;
					xPixel -= cubeFaceWidth;
					yPixel -= cubeFaceHeight;
					if (xPixel >= 2048)
						xPixel = 2047; if (yPixel >= 2048)
						yPixel = 2047;

					arr[this.my_h * i * 4 + j * 4] = front[cubeFaceHeight * yPixel * 4 + xPixel * 4];
					arr[this.my_h * i * 4 + j * 4 + 1] = front[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 1];
					arr[this.my_h * i * 4 + j * 4 + 2] = front[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 2];
					arr[this.my_h * i * 4 + j * 4 + 3] = front[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 3];
				}
				else if (za == -1) {
					//back
					xPixel = ((((xa + 1) / 2) - 1) * cubeFaceWidth); xPixel = Math.round(xPixel);
					xOffset = 3 * cubeFaceWidth;
					yPixel = ((((ya + 1) / 2)) * cubeFaceHeight); yPixel = Math.round(yPixel);
					yOffset = cubeFaceHeight;
					xPixel = Math.abs(xPixel);
					yPixel = Math.abs(yPixel);

					xPixel += xOffset;
					yPixel += yOffset;

					xPixel -= 3 * cubeFaceWidth;
					yPixel -= cubeFaceHeight;

					if (xPixel >= 2048)
						xPixel = 2047; if (yPixel >= 2048)
						yPixel = 2047;

					arr[this.my_h * i * 4 + j * 4] = back[cubeFaceHeight * yPixel * 4 + xPixel * 4];
					arr[this.my_h * i * 4 + j * 4 + 1] = back[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 1];
					arr[this.my_h * i * 4 + j * 4 + 2] = back[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 2];
					arr[this.my_h * i * 4 + j * 4 + 3] = back[cubeFaceHeight * yPixel * 4 + xPixel * 4 + 3];
				}
				else//	其他255;//
				{
					//Debug.LogWarning("未知的面孔,出错了"); 
					console.log(i + " " + j + "未知的面孔,出错了" + xa + " " + ya + " " + za);
					xPixel = 0;
					yPixel = 0;
					xOffset = 0;
					yOffset = 0;
				}
			}
		}
		let textureContext = texture.getContext();
		let imageData = new ImageData(arr, this.my_w, this.my_h);
		textureContext.putImageData(imageData, 0, 0);
		texture.update();
		this.box?.setEnabled(true);
		if (this.box != null) {
			let mat = new BABYLON.StandardMaterial("mat", scene);
			mat.diffuseTexture = texture;
			console.log(this.box.position + " " + texture.isReady());
			this.box.position.x = this.camera.position.x;
			this.box.position.y = this.camera.position.y;
			this.box.position.z = this.camera.position.z;
			console.log(this.box.position + " " + texture.isReady());
			this.box.position.z += 170;
			// this.box.position.y+=170;
			console.log(this.box.position + " " + this.camera.position);
			this.box.material = mat;
		}

	}

	create_custom3(scene:BABYLON.Scene,mat:BABYLON.Material)
	{
	  var customMesh = new BABYLON.Mesh("custom3", scene);
  
	  var positions = [0,0,0,0,60,0,60*6,60,0,60*6,0,0];
	  var indices = [0, 1, 2, 0,2,3];
	  var uv=[1,1, 1,0, 0,0, 0,1, 1,1, 0,0];
	  
	  var vertexData = new BABYLON.VertexData();
	  
	  vertexData.positions = positions;
	  vertexData.indices = indices;    
	  vertexData.uvs=uv;
	  vertexData.applyToMesh(customMesh);
	  customMesh.material=mat;
	  customMesh.position=new BABYLON.Vector3(0,10,30);
	  // customMesh.rotation.x+=Math.PI/2;
	  // customMesh.position=new BABYLON.Vector3(-2520.891357421875 ,170.20770263671875 ,450);//(2240.7687 ,-279.6507 ,555.9809);
	}
  
	create_custom4(scene:BABYLON.Scene,mat:BABYLON.Material)
	{
	  var customMesh = new BABYLON.Mesh("custom4", scene);
  
	  var positions = [-60*5,0,0,-60*5,60*5,0,0,60*5,0,0,0,0];
	  var indices = [2, 1, 0, 3,2,0];
	  var uv=[1,1, 1,0, 0,0, 0,1, 1,1, 0,0];
	  let s=1/(1024*8);
	  var uv=[1026*5/(1024*8)-s,1,1026*5/(1024*8)-s,0, 1026*4/(1024*8)+s,0,1026*4/(1024*8)+s,1];
	  var vertexData = new BABYLON.VertexData();
	  
	  vertexData.positions = positions;
	  vertexData.indices = indices;    
	  vertexData.uvs=uv;
	  vertexData.applyToMesh(customMesh);
	  customMesh.material=mat;
	  // customMesh.position=new BABYLON.Vector3(0,10,30);
	  // customMesh.rotation.x+=Math.PI/2;
	  customMesh.position=new BABYLON.Vector3(-2200.891357421875 ,170.20770263671875 ,500);//(2240.7687 ,-279.6507 ,555.9809);
	}
}